// const url = "https://node.cambeo.co.uk/"
// const url = "https://node.cambeo.co.uk/"
// const url = "https://node.cambeo.co.uk/"
//const url = "https://node.cambeo.co.uk/"
const url = "https://node.cambeo.co.uk/"

export const BASE_URL = url

const user = `${url}api/v1/user`
const admin = `${url}api/v1/admin`
const tag = `${url}api/v1/tag`
const activity = `${url}api/v1/activity`
const cuisine = `${url}api/v1/cuisine`
const drink = `${url}api/v1/drink`
const dish = `${url}api/v1/dish`
const food = `${url}api/v1/food`
const offer = `${url}api/v1/offer`
const facility = `${url}api/v1/facility`
const notifications = `${url}api/v1/notifications`
const trackPageHits = `${url}api/v1/track`
const analytics = `${url}api/v1/analytics`
const engagement = `${url}api/v1/engagement`
const emails = `${url}api/v1/emails`
const notificationTemplates = `${url}api/v1/notification-templates`
const venueDetails = `${url}api/v1/venueDetails`
const offerTags = `${url}api/v1/offerTypes`
const experiences = `${url}api/v1/experiences`
const offerCategories = `${url}api/v1/offerCategories`
const venueTypes = `${url}api/v1/venueTypes`

const ApiConfig = {
  login: `${user}/login`,
  resendOTP: `${user}/resendOTP`,
  verifyOTP: `${user}/verifyOTP`,
  resetPassword: `${user}/resetPassword`,
  uploadFile: `${user}/uploadFile`,
  createCategory: `${user}/createCategory`,
  getProfile: `${user}/getProfile`,
  updateProfile: `${user}/updateProfile`,
  changePassword: `${user}/changePassword`,
  businessUserList: `${user}/businessUserList`,
  userList: `${admin}/userList`,
  updateUser: `${admin}/updateUser`,
  viewUserDetails: `${admin}/viewUserDetails`,
  sendBillingInvite: `${admin}/sendBillingInvite`,
  businessOwnerOfferListForAdmin: `${admin}/businessOwnerOfferListForAdmin`,
  feedbackList: `${admin}/feedbackList`,
  venueList: `${admin}/venueList`,
  tagList: `${tag}/tagList`,
  createAccount: `${user}/createAccount`,
  createTag: `${tag}/createTag`,
  adminActivityList: `${activity}/adminActivityList`,
  createActivity: `${activity}/createActivity`,
  updateActivity: `${activity}/updateActivity`,
  updateTag: `${tag}/updateTag`,
  tagDetails: `${tag}/tagDetails`,
  adminCuisineList: `${cuisine}/adminCuisineList`,
  updateCuisine: `${cuisine}/updateCuisine`,
  cuisineDetails: `${cuisine}/cuisineDetails`,
  createCuisine: `${cuisine}/createCuisine`,
  adminDrinkList: `${drink}/adminDrinkList`,
  updateDrink: `${drink}/updateDrink`,
  drinkDetails: `${drink}/drinkDetails`,
  createDrink: `${drink}/createDrink`,
  addOffer: `${offer}/addOffer`,
  updateOffer: `${offer}/updateOffer`,
  offerListForBusinessOwner: `${offer}/offerListForBusinessOwner`,
  sendNotification: `${notifications}/send`,

  marketingInsights: `${trackPageHits}/hits`,

  sendMassEmail: `${emails}/send`,
  getMailingLists: `${emails}/mailing-lists`,
  createMailingList: `${emails}/mailing-lists`,
  updateMailingList: id => `${emails}/mailing-lists/${id}`,
  deleteMailingList: id => `${emails}/mailing-lists/${id}`,
  getEmailHistory: `${emails}/history`,
  getEmailTemplates: `${emails}/templates`,
  getEmailTemplateById: id => `${emails}/templates/${id}`,

  notificationTemplates: `${notificationTemplates}`,
  notificationTemplateById: id => `${notificationTemplates}/${id}`,
  notificationTemplateStats: `${notificationTemplates}/stats`,
  notificationTemplateResetStats: id => `${notificationTemplates}/${id}/reset-stats`,
  notificationTemplateSyncStats: `${notificationTemplates}/sync-stats`,
  notificationTemplateTrackClick: `${notificationTemplates}/track-click`,

  analyticsNotifications: `${analytics}/notification`,
  analyticsOfferRedemptions: `${analytics}/redemptions`,
  redemptionsById: offerId => `${analytics}/redemptions/${offerId}`,

  engagementAnalytics: `${engagement}/analytics`,
  engagementUsers: `${engagement}/users`,
  analyticsAppOpenLogs: `${analytics}/appOpenLogs`,
  analyticsBusinessEngagement: `${analytics}/business-engagement`,

  viewStaticContent: `${admin}/viewStaticContent`,
  updateStaticContent: `${admin}/updateStaticContent`,
  staticContentList: `${admin}/staticContentList`,
  addStaticContent: `${admin}/addStaticContent`,
  createSubAdmin: `${admin}/createSubAdmin`,
  updateVenue: `${admin}/updateVenue`,
  viewVenueByVenueId: `${admin}/viewVenueByVenueId`,
  newOfferListing: `${admin}/newOfferListing`,
  getDashboardForRegisterData: `${admin}/getDashboardForRegisterData`,
  businessCount: `${admin}/businessCount`,
  offerCount: `${admin}/offerCount`,
  offerDashBoard: `${admin}/offerDashBoard`,
  quickFiltersAdmin: `${admin}/quickFilters`,

  dishlist: `${dish}/adminDishList`,
  updateDish: `${dish}/updateDish`,
  getDish: `${dish}/dishDetails`,
  createDish: `${dish}/createDish`,

  foodlist: `${food}/adminFoodList`,
  getFood: `${food}/foodDetails`,
  updateFood: `${food}/updateFood`,
  createFood: `${food}/createFood`,

  venueDetails: `${venueDetails}`,
  adminVenueDetails: `${venueDetails}/admin/list`,
  offerTags: `${offerTags}`,
  adminOfferTags: `${offerTags}/admin/list`,
  getTagOptions: `${url}api/v1/offer/getTagOptions`,
  experiences: `${experiences}`,
  adminExperiences: `${experiences}/admin/list`,
  offerCategories: `${offerCategories}`,
  adminOfferCategories: `${offerCategories}/admin/list`,
  venueTypes: `${venueTypes}`,
  adminVenueTypes: `${venueTypes}/admin/list`,

  createFacility: `${facility}/createFacility`,
  adminFacilityList: `${facility}/adminFacilityList`,
  updateFacility: `${facility}/updateFacility`,

  // Business ownership transfer (transfers all venues and business users)
  transferBusinessOwnership: userId => `${url}api/v1/admin/users/${userId}/transfer-ownership`,

  // Offer detail (RESTful admin endpoint)
  adminOfferById: offerId => `${url}api/v1/admin/offers/${offerId}`,
  adminOffersSpontaneous: `${url}api/v1/admin/offers/spontaneous`,
  adminOffersExisting: `${url}api/v1/admin/offers/existing`,

  // GDPR user deletion
  deleteUser: userId => `${url}api/v1/admin/users/${userId}`,

  // Admin-triggered password reset
  sendResetPassword: userId => `${url}api/v1/admin/users/${userId}/send-reset-password`,

  // Bulk user status update
  bulkUpdateUsers: `${url}api/v1/admin/users/bulk`,

  // Audit log
  auditLog: `${url}api/v1/admin/audit-log`,

  // Internal notes
  adminNotes: `${url}api/v1/admin/notes`,
  adminNoteById: noteId => `${url}api/v1/admin/notes/${noteId}`
}

export default ApiConfig
